
  export const CAMBIOORDENCAMBIOS_RECEIVED = "CAMBIOORDENCAMBIOS_RECEIVED";
  export const SET_CAMBIOORDENCAMBIO = "SET_CAMBIOORDENCAMBIO";
  export const CREATE_CAMBIOORDENCAMBIO = "CREATE_CAMBIOORDENCAMBIO";
  export const SET_PROPERTY_CAMBIOORDENCAMBIO = "SET_PROPERTY_CAMBIOORDENCAMBIO";
  